import React from 'react';
import PropTypes from 'prop-types';
import {
    FormattedMessage,
} from 'react-intl';
import styled from 'styled-components';
import classNames from 'classnames';

import { DefaultIntlFormatValues, isWidget } from '@ratehub/base-ui';

import AdvertisingDisclosure from './AdvertisingDisclosure';


const PRODUCT_TABLE_TITLE_ELEMENT_TYPES = [ 'h1', 'h2' ];

function ProductTableHeader({
    title,
    titleAs = 'h2',
    lastUpdatedDate,
    className,
    ...otherProps
}) {
    const TitleElement = titleAs;

    // Requirement: We don't want the ad disclosure to show on non Ratehub sites
    const showAdDisclosure = !isWidget();

    return (
        <header
            className={classNames('rh-mb-1', className)}
            {...otherProps}
        >
            <If condition={title}>
                <TitleElement className="rh-title-2xl rh-my-0_5 showDot">
                    {title}
                </TitleElement>
            </If>
            <div className="header-container">
                <If condition={lastUpdatedDate}>
                    <p className="rh-text-s rh-my-0 rh-mr-0_25">
                        <FormattedMessage
                            id="web-components.ProductTableMortgagesV2.rates-updated"
                            defaultMessage="As of: <longDate>{lastUpdatedDate, date, long} {lastUpdatedDate, time, short}</longDate>"
                            values={{
                                lastUpdatedDate: new Date(lastUpdatedDate),
                                ...DefaultIntlFormatValues,
                            }}
                        />
                    </p>
                </If>
                <If condition={showAdDisclosure}>
                    <AdvertisingDisclosure
                        className="disclosure-button rh-ml-auto"
                        size="extra-small"
                    />
                </If>
            </div>
        </header>
    );
}

ProductTableHeader.propTypes = {
    title: PropTypes.node,
    titleAs: PropTypes.oneOf(PRODUCT_TABLE_TITLE_ELEMENT_TYPES),
    lastUpdatedDate: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
    ]),
    className: PropTypes.string,
};

const StyledProductTableHeader = styled(ProductTableHeader)`
    > .header-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: nowrap;

        > .disclosure-button {
            flex-shrink: 0;
            white-space: nowrap;

            /* Ensures alignment with the rates updated text */
            margin: 1px;
        }
    }
`;

export default StyledProductTableHeader;
export { PRODUCT_TABLE_TITLE_ELEMENT_TYPES };
